import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.uipage');
import { OnInit, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-uipage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.uipage/view.scss */
/* src/app/page.uipage/view.scss: no such file or directory */`],
})
export class PageUipageComponent implements OnInit, DoCheck {
    public category: any;  // 'dashboard' | 'mypage' | 'rawdata' | 'dataset' | 'service'
    public type: any;      // dataset/service 하위 탭
    public id: any;        // rawdata detail, dataset/service detail 공통

    private prevCategory: any;
    private prevType: any;
    private prevId: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();
        this.syncRoute();
        this.session = this.service.auth.session;
        await this.service.render();
    }

    public ngDoCheck() {
        this.syncRoute();
    }

    private syncRoute() {
        const seg = (typeof WizRoute !== 'undefined' && WizRoute.segment)
            ? WizRoute.segment
            : {};

        let category = seg.category || 'dashboard';
        let type = seg.type || null;
        let id = seg.id || null;

        // ✅ /ui/<category>/<id> 패턴을 쓰는 카테고리들
        if (category === 'rawdata' || category === 'qadataset' || category === 'qainstruct') {
            id = seg.type || null;  // /ui/rawdata/:id, /ui/qadataset/:id 모두 지원
            type = null;            // 이 둘은 type 개념 안 씀
        }

        if (this.prevCategory === category &&
            this.prevType === type &&
            this.prevId === id) {
            return;
        }

        this.category = category;
        this.type = type;
        this.id = id;

        this.prevCategory = category;
        this.prevType = type;
        this.prevId = id;
    }
    public isReviewLogPage(): boolean {
        return this.router.url.includes('/reviewlog');
    }
}

export default PageUipageComponent;